<div class="flex gap-1 flex-col">
  <span *ngFor="let error of errors; let i = index" class="text-xs font-primary flex flex-row items-center gap-1" [ngClass]="{ 'text-white': errorTextColor === 'primary', 'text-state-error-700': errorTextColor === 'secondary', 'icon circular-dot before:text-[6px]': showAsUnorderedList }">
    <span *ngIf="showAsOrderedlist">{{ i + 1 }}. </span>
    {{ error.value || error | translate }}</span
  >
</div>
